import i18n from '@/i18n/index'

export const private_routes = [
  {
    icon: 'mdi-home',
    name: i18n.t('route.home'),
    path: '/:org_id/home',
    link_path: '',
    component: () => import('@/views/Home.vue'),
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.home'),
          disabled: true,
        },
      ],
      is_required_login: true,
    },
  },
  {
    icon: 'mdi-home',
    name: i18n.t('route.home'),
    path: '/:org_id/:container_id/home',
    link_path: '',
    component: () => import('@/views/Home.vue'),
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.home'),
          disabled: true,
        },
      ],
      is_required_login: true,
    },
  },
  {
    icon: 'mdi-toolbox',
    name: i18n.t('route.siteOptimization'),
    path: '/:org_id/:container_id/optimize_site/',
    link_path: '',
    feature: 'optimize_site',
    component: () => import('@/components/Utils/PageIndex.vue'),
    children: [
      {
        feature: 'marketing_card',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/marketing_card',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_site/marketing_card/',
        link_path: 'optimize_site/marketing_card',
        name: i18n.t('route.adVisual'),
        component: () => import('@/views/OptimizeSite/MarketingCard/MarketingCardSettingSettingCardList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.siteOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.adVisual'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/marketing_card',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_site/marketing_card/edit',
        link_path: 'optimize_site/marketing_card/edit',
        name: i18n.t('route.adVisualEditor'),
        component: () => import('@/views/OptimizeSite/MarketingCard/MarketingCardEdit.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.siteOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.adVisual'),
              disabled: false,
            },
            {
              text: i18n.t('route.create'),
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'floating_menu_setting',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/floating_menu_setting',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_site/floating_menu_setting',
        link_path: 'optimize_site/floating_menu_setting',
        name: i18n.t('route.floatingMenu'),
        invisibility_sidebar: true,
        component: () => import('@/views/OptimizeSite/FloatingMenuSetting.vue'),
        meta: {
          is_required_login: true,
        },
      },
      {
        feature: 'interesting_search',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/interesting_search',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_site/interesting_search/',
        link_path: 'optimize_site/interesting_search/',
        component: () => import('@/views/OptimizeSite/InterestingSearch/SearchList.vue'),
        name: i18n.t('route.interestSearch'),
        invisibility_sidebar: true,
        show_levels: ['nineder'],
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.siteOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.interestSearch'),
              disabled: false,
            },
          ],
          is_required_login: true,
          activate_levels: ['Nineder'],
        },
      },
      {
        feature: 'global_setting',
        path: '/:org_id/:container_id/optimize_site/global_setting/',
        link_path: 'optimize_site/global_setting/',
        name: i18n.t('route.oneClickSwapImage'),
        component: () => import('@/views/OptimizeSite/GlobalSetting/List.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.siteOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.oneClickSwapImage'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-image-multiple',
    name: i18n.t('route.pageOptimization'),
    path: '/:org_id/:container_id/container',
    link_path: '',
    feature: 'optimize_page',
    component: () => import('@/components/Utils/PageIndex.vue'),
    children: [
      // {
      //   feature: '',
      //   path: '/:org_id/:container_id/container',
      //   link_path: '',
      //   name: i18n.t('route.container'),
      //   component: () => import('@/views/Setting/Container/ContainerList.vue'),
      //   meta: {
      //     is_required_login: true,
      //   },
      // },
      {
        feature: 'experiments',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/experiment',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/experiments',
        link_path: 'optimize_page/experiments',
        name: i18n.t('route.experiment'),
        component: () => import('@/views/OptimizePage/Experiment/ExperimentList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.experiment'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'version',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/experiment',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/experiments/:experiment_id/',
        link_path: '',
        name: i18n.t('route.version'),
        component: () => import('@/views/OptimizePage/Experiment/VersionList.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.experiment'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'page_editor',
        required_auth: [
          {
            url: '/web_attribute/optimize/experiment',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/page_editor',
        link_path: '',
        name: i18n.t('route.pageEditor'),
        component: () => import('@/views/OptimizePage/Experiment/OptimizePageEditorApp.vue'),
        invisibility_sidebar: true,
        meta: {
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/iframe_timer',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/iframe_timer/new',
        link_path: 'optimize_page/iframe_timer/new',
        name: i18n.t('route.edit'),
        component: () => import('@/views/OptimizePage/IframeTimer/TimerEditor.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.countdownTimer'),
              disabled: false,
            },
            {
              text: i18n.t('route.create'),
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/iframe_timer',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/iframe_timer/:iframe_id/edit',
        link_path: '',
        name: i18n.t('route.edit'),
        component: () => import('@/views/OptimizePage/IframeTimer/TimerEditor.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.countdownTimer'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'page_plugin',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/experiment',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/page_plugin/',
        link_path: 'optimize_page/page_plugin',
        name: i18n.t('route.impulsePlugin'),
        component: () => import('@/views/OptimizePage/PagePlugin/List.vue'),
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.impulsePlugin'),
              disabled: true,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'sale_counter',
        path: '/:org_id/:container_id/optimize_page/page_plugin/:id',
        name: i18n.t('route.editImpulsePlugin'),
        component: () => import('@/views/OptimizePage/PagePlugin/Edit.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.impulsePlugin'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'iframe_timer',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/iframe_timer',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_page/iframe_timer',
        link_path: 'optimize_page/iframe_timer/',
        name: i18n.t('route.countdownTimer'),
        component: () => import('@/views/OptimizePage/IframeTimer/TimerList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.countdownTimer'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/',
        link_path: 'optimize_page/invoice_collector/',
        name: i18n.t('route.invoiceCollector'),
        component: () => import('@/views/OptimizePage/InvoiceCollector/InvoiceList.vue'),
        invisibility_sidebar: true,
        show_levels: ['nineder'],
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.invoiceCollector'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        invisibility_sidebar: true,
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/:id',
        link_path: 'optimize_page/invoice_collector/:id',
        name: i18n.t('route.invoiceCollector'),
        component: () => import('@/views/OptimizePage/InvoiceCollector/InvoiceEditor.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.invoiceCollector'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
      {
        invisibility_sidebar: true,
        feature: 'invoice_collector',
        path: '/:org_id/:container_id/optimize_page/invoice_collector/:id/data',
        link_path: 'optimize_page/invoice_collector/:id/data',
        name: i18n.t('route.invoiceData'),
        component: () => import('@/views/OptimizePage/InvoiceCollector/InvoiceData.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.pageOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.invoiceData'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-cart-arrow-up',
    name: i18n.t('route.checkoutOptimization'),
    path: '/:org_id/:container_id/optimize_checkout',
    link_path: '',
    feature: 'optimize_checkout',
    component: () => import('@/components/Utils/PageIndex.vue'),
    children: [
      {
        feature: 'login',
        required_auth_rules: [
          {
            url: '/web_attribute/optimize/login',
            method: 'GET',
          },
        ],
        path: '/:org_id/:container_id/optimize_checkout/login',
        link_path: 'optimize_checkout/login',
        name: i18n.t('route.loginError'),
        component: () => import('@/views/OptimizeCheckout/Login/DetectLogin.vue'),
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.checkoutOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.loginError'),
              disabled: false,
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-file-export-outline',
    name: i18n.t('route.dataExport'),
    path: '/:org_id/:container_id/export/',
    link_path: '',
    component: () => import('@/components/Utils/PageIndex.vue'),
    feature: 'job',
    invisibility_sidebar: true,
    show_levels: ['nineder'],
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.dataExport'),
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'job',
        path: '/:org_id/:container_id/export/jobs/',
        link_path: 'export/jobs/',
        name: i18n.t('route.taskProgress'),
        component: () => import('@/views/ExportBatch/BatchList.vue'),
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.dataExport'),
              disabled: true,
            },
            {
              text: i18n.t('route.taskProgress'),
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-folder-outline',
    name: i18n.t('route.catalogOptimization'),
    path: '/:org_id/:container_id/category/',
    link_path: '',
    component: () => import('@/components/Utils/PageIndex.vue'),
    feature: 'category',
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.catalogOptimization'),
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'category',
        path: '/:org_id/:container_id/category/water_marker/',
        link_path: 'category/water_marker/',
        name: i18n.t('route.watermark'),
        component: () => import('@/views/OptimizeCategory/WaterMarkerList.vue'),
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.catalogOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.watermark'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'category',
        path: '/:org_id/:container_id/category/water_marker/edit',
        link_path: 'category/water_marker/edit',
        name: i18n.t('route.watermarkSettings'),
        component: () => import('@/views/OptimizeCategory/WaterMarkerEdit.vue'),
        invisibility_sidebar: true,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.catalogOptimization'),
              disabled: true,
            },
            {
              text: i18n.t('route.watermark'),
            },
            {
              text: i18n.t('route.create'),
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-tools',
    name: i18n.t('route.otherFeatures'),
    path: '/:org_id/:container_id/toolbox/',
    link_path: '',
    component: () => import('@/components/Utils/PageIndex.vue'),
    feature: 'toolbox',
    invisibility_sidebar: false,
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.otherFeatures'),
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        name: i18n.t('route.imageGallery'),
        path: '/:org_id/:container_id/toolbox/image_gallery',
        link_path: 'toolbox/image_gallery',
        component: () => import('@/views/OptimizePage/imageGallery.vue'),
        is_sidebar_bottom: false,
        invisibility_sidebar: false,
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.otherFeatures'),
              disabled: true,
            },
            {
              text: i18n.t('route.imageGallery'),
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-handshake',
    name: i18n.t('route.collaborationFeatures'),
    path: '/:org_id/:container_id/partner/',
    link_path: '',
    component: () => import('@/components/Utils/PageIndex.vue'),
    feature: 'partner',
    invisibility_sidebar: true,
    show_levels: ['nineder', 'bussiness', 'starter', 'free', 'disabled'],
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.collaborationFeatures'),
        },
      ],
      is_required_login: true,
      is_required_partner_user: true,
    },
    children: [
      {
        feature: 'partner',
        path: '/:org_id/:container_id/partner/readme_map',
        link_path: 'partner/readme_map',
        name: i18n.t('route.frontendInstructions'),
        component: () => import('@/views/PartnerFeature/ReadmeMap.vue'),
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.collaborationFeatures'),
              disabled: true,
            },
            {
              text: i18n.t('route.frontendInstructions'),
            },
          ],
          is_required_login: true,
          is_required_partner_user: true,
        },
      },
    ],
  },
  {
    icon: 'mdi-cog',
    name: i18n.t('route.setting'),
    path: '/:org_id/setting/',
    link_path: '',
    component: () => import('@/components/Utils/PageIndex.vue'),
    feature: 'setting',
    invisibility_sidebar: true,
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.setting'),
        },
      ],
      is_required_login: true,
    },
    children: [
      {
        feature: 'staff',
        path: '/:org_id/setting/staffs/',
        link_path: 'setting/staffs/',
        name: i18n.t('route.member'),
        component: () => import('@/views/Setting/Staff/StaffList.vue'),
        // 如果要靜態的話，照這個格式設定就可以了
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.member'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'containers',
        path: '/:org_id/setting/containers/:container_id/edit',
        name: i18n.t('route.editContainer'),
        component: () => import('@/views/Setting/Container/ContainerEdit.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.container'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: 'containers',
        path: '/:org_id/setting/containers',
        link_path: 'setting/containers',
        name: i18n.t('route.container'),
        component: () => import('@/views/Setting/Container/ContainerList.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.container'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/staffs/:staff_id/edit',
        link_path: '',
        name: i18n.t('route.administrator'),
        component: () => import('@/views/Setting/Staff/StaffEdit.vue'),
        // 如果要動態的話，看StaffEdit這個元件
        // 1. created 先用commit update_breadcrumbs 更新 vuex裡面的replace_breadcrumbs
        // 2. beforeRouteLeave，再用commit update_breadcrumbs ，清空這個元件強迫顯示的replace_breadcrumbs
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.member'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/subscription/',
        link_path: 'setting/subscription/',
        name: i18n.t('route.subscription'),
        component: () => import('@/views/Setting/Subscription/StaffMemberLevel.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.subscription'),
            },
          ],
          is_required_login: true,
        },
      },
      {
        feature: '',
        path: '/:org_id/setting/organization',
        link_path: 'setting/organization',
        name: i18n.t('route.organization'),
        component: () => import('@/views/Setting/Organization/Organization.vue'),
        meta: {
          breadcrumbs: [
            {
              text: i18n.t('route.organizationSettings'),
            },
            {
              text: i18n.t('route.organization'),
            },
          ],
          is_required_login: true,
        },
      },
    ],
  },
  {
    path: '/:org_id/401',
    component: () => import('@/views/Error/Forbidden.vue'),
    invisibility_sidebar: true,
    name: 'Unauthorized',
    meta: {
      breadcrumbs: [
        {
          text: i18n.t('route.noAccessPermission'),
        },
      ],
    },
  },
  {
    path: '/:org_id/*',
    component: () => import('@/views/Error/NotFound.vue'),
    invisibility_sidebar: true,
    meta: {
      is_required_login: true,
    },
  },
]
